import { Button } from 'antd';
import { nanoid } from 'nanoid';
import { PlusOutlined } from '@ant-design/icons';
import { AddIntervalButtonProps } from '@modules/timetable';

export const AddIntervalButton = ({ size, append }: AddIntervalButtonProps) => {
  return (
    <Button
      size={size}
      type="dashed"
      onClick={() => {
        append({ id: nanoid() });
      }}
    >
      <PlusOutlined /> Add Slot &nbsp;
    </Button>
  );
};
